/** Google Analytics 4 — ID вида G-XXXXXXXXXX */
export const GA_ID = process.env.REACT_APP_GA_ID?.trim() || '';
export const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION?.trim() || '';

export const initAnalytics = () => {
  if (GSC_VERIFICATION) {
    let meta = document.querySelector('meta[name="google-site-verification"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'google-site-verification');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', GSC_VERIFICATION);
  }

  if (!GA_ID || typeof window.gtag === 'function') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

export const trackPageView = (path) => {
  if (!GA_ID || typeof window.gtag !== 'function' || !path) {
    return;
  }
  window.gtag('config', GA_ID, { page_path: path });
};

export const trackViewItem = (product) => {
  if (!GA_ID || typeof window.gtag !== 'function' || !product?.id) {
    return;
  }
  window.gtag('event', 'view_item', {
    currency: 'UAH',
    value: Number(product.price) || 0,
    items: [{
      item_id: String(product.id),
      item_name: product.title,
      price: Number(product.price) || 0,
      quantity: 1,
    }],
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  if (!GA_ID || typeof window.gtag !== 'function' || !product?.id) {
    return;
  }
  window.gtag('event', 'add_to_cart', {
    currency: 'UAH',
    value: (Number(product.price) || 0) * quantity,
    items: [{
      item_id: String(product.id),
      item_name: product.title,
      price: Number(product.price) || 0,
      quantity,
    }],
  });
};

export const trackPurchase = (order) => {
  if (!GA_ID || typeof window.gtag !== 'function' || !order) {
    return;
  }
  const items = (order.items || []).map((item) => ({
    item_id: String(item.id),
    item_name: item.title,
    price: Number(item.price) || 0,
    quantity: Number(item.quantity) || 1,
  }));
  const value = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

  window.gtag('event', 'purchase', {
    transaction_id: String(order.id || Date.now()),
    currency: 'UAH',
    value,
    items,
  });
};
